import styled from 'styled-components';
import GreetingSection from '../GreetingSection/GreetingSection';
import RenderLayoutViews from '../shared/RenderLayoutViews';
import { isUserLoggedIn } from '../../../../lib/user';

const ScreenReaderOnlyH1 = styled.h1`
  position:absolute;
  left:-10000px;
  top:auto;
  width:1px;
  height:1px;
  overflow:hidden;
`;

const HomeContent = (props) => {
  const {
    userData,
    globalGreetingSectionConfig,
    urlLocale,
    userShopsData,
    pageStateModifiers,
    adConfig,
    anonLayout,
    loggedLayout,
    headerSectionData,
    pageHeader,
    globalPageConfig,
  } = props;

  const {
    greetingSectionLayoutPosition = 0,
  } = globalGreetingSectionConfig;

  const preGreetingSectionLayout = loggedLayout && (
    loggedLayout.slice(0, greetingSectionLayoutPosition)
  );
  const postGreetingSectionLayout = loggedLayout && (
    loggedLayout.slice(greetingSectionLayoutPosition)
  );

  const userFirstName = userData.visitInfo
    ? userData.visitInfo.firstName
    : '';

  return (
    <div>
      <ScreenReaderOnlyH1>{ pageHeader }</ScreenReaderOnlyH1>
      {/* Logged Layout placed before greeting section */}
      {isUserLoggedIn(userData) && (
        <RenderLayoutViews
          key="preGreetingSectionLayout"
          views={preGreetingSectionLayout}
          locale={urlLocale}
          userData={userData}
          pageStateModifiers={pageStateModifiers}
          adConfig={adConfig}
          globalPageConfig={globalPageConfig}
        />
      )}

      <GreetingSection
        globalGreetingSectionConfig={globalGreetingSectionConfig}
        locale={urlLocale}
        isUserLoggedIn={() => isUserLoggedIn(userData)}
        firstName={userFirstName}
        userShopsData={userShopsData}
        pageStateModifiers={pageStateModifiers}
        headerSectionData={headerSectionData}
      />

      {/* Anon Layout */}
      {!isUserLoggedIn(userData) && (
        <RenderLayoutViews
          views={anonLayout}
          locale={urlLocale}
          userData={userData}
          pageStateModifiers={pageStateModifiers}
          adConfig={adConfig}
          globalPageConfig={globalPageConfig}
        />
      )}

      {/* Logged Layout placed after greeting section */}
      {isUserLoggedIn(userData) && (
        <RenderLayoutViews
          key="postGreetingSectionLayout"
          views={postGreetingSectionLayout}
          locale={urlLocale}
          userData={userData}
          pageStateModifiers={pageStateModifiers}
          adConfig={adConfig}
          globalPageConfig={globalPageConfig}
        />
      )}
    </div>
  );
};

export default HomeContent;
